// extracted by mini-css-extract-plugin
module.exports = {"container":"AnswerText_container__6Plx6","TextScroll":"AnswerText_TextScroll__1ZrPh","Main":"AnswerText_Main__4G3qC"};